module.exports = __webpack_public_path__ + "img/hero-bg.7cb46e15.jpg";